(function(){
  var tags = [],
      filteredProducts = [],
      endlessScroll = null;
  
  
  var moneyformat = window.theme.currency.moneyWithCurrencyFormat;
  

  function initSliders(){
    const swiperContainers = document.querySelectorAll('.tile-media-slider');

    swiperContainers.forEach(element => {
            const new_swiper = new Swiper(element, {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                preloadImages: false,
                lazy: true
            });

            const isNextEnabled = element.getAttribute('data-next-enabled') === 'true';
            // Add listener for mouse entering the container
            element.addEventListener('mouseenter', () => {
                if (isNextEnabled && new_swiper) {
                    new_swiper.slideNext();
                }
            });

            // Add listener for mouse leaving the container
            element.addEventListener('mouseleave', () => {
                // Return to the first slide
                if (isNextEnabled && new_swiper){
                    new_swiper.slideTo(0);
                }
            });
    });
  }



  document.addEventListener("DOMContentLoaded", function() {
    initSliders();

  });
  
})();

function imgUrl(src, size = '300x') {
  if (!src) return '';
  
  // split URL into [basename, extension]
  const parts = src.split('?'); // separate query string
  const baseUrl = parts[0];
  const query = parts[1] ? '?' + parts[1] : '';

  const lastDot = baseUrl.lastIndexOf('.');
  if (lastDot === -1) return src; // no extension

  const name = baseUrl.substring(0, lastDot);
  const ext = baseUrl.substring(lastDot);

  return `${name}_${size}${ext}${query}`;
}

class ColorSelectionStore {
  constructor() {
    this.items = [];
    this.cartPrice = {
      price: 0,
      compare: 0,
    };
    this.listeners = new Set();

    this._state = {
      maxItems : 0,
      freeItems : 0,
      optionalItems : 0,
      requiredOff : 0,
      optionalOff : 0,
    }
  }

    // --- General Getter ---
  get(prop) {
    return this._state[prop];
  }

  // --- General Setter (triggers notify) ---
  set(prop, value) {
    if (!(prop in this._state)) {
      throw new Error(`Property "${prop}" does not exist in store.`);
    }
    this._state[prop] = value;
    this._applyDiscounts();
    this._calculateCartPrice();
    this.notify();
  }

  getItems() {
    return this.items;
  }

  getCartPrice() {
    return this.cartPrice;
  }

  _applyDiscounts() {
    const { requiredOff } = this._state;

    this.items = this.items.map(item => {
      let compare = item.compare;
      let price   = compare - ((requiredOff * compare) / 100);
      return { ...item, price, compare };
    });
  }

  _calculateCartPrice() {
    // Simple example: sum of item.price
    const total = this.items.reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0);

    // If you also want a “compare at” price, compute it here
    const compareTotal = this.items.reduce(
      (sum, item) => sum + (parseFloat(item.compare) || parseFloat(item.price) || 0),
      0
    );

    this.cartPrice = {price: total, compare: compareTotal};
  }

  subscribe(fn) {
    this.listeners.add(fn);
    // Call immediately with current state (optional, but useful)
    fn(this.items);
    // Return unsubscribe function
    return () => this.listeners.delete(fn);
  }

  notify() {
    this.listeners.forEach(fn => fn(this.items));
  }

  _cartAddSucceeded(data) {
    return !!(data && !(data.status && Number(data.status) >= 400));
  }

  /**
   * Upcart embed owns the cart drawer when loaded. Opening the theme #cart-bag
   * at the same time leaves it under Upcart — closing Upcart then shows that UI.
   */
  _isUpcartPresent() {
    try {
      if (window.Upcart || window.upcart || window.__UPCART__) return true;
    } catch (e) {}
    if (
      document.querySelector(
        '[data-upcart], upcart-app, #upcart, [class*="upcart" i], [id*="upcart" i]'
      )
    ) {
      return true;
    }
    return [...document.scripts].some((s) => /upcart/i.test(s.src || ""));
  }

  _closeThemeCartDrawer() {
    const bag = document.getElementById("cart-bag");
    if (bag) bag.classList.remove("-active");
    document.querySelector(".overlay")?.classList.remove("active");
  }

  /** Open Upcart when present; otherwise open the theme mini-cart. */
  _notifyCartOpened() {
    if (this._isUpcartPresent()) {
      this._closeThemeCartDrawer();
      try {
        if (window.Upcart && typeof window.Upcart.open === "function") {
          window.Upcart.open();
        } else if (typeof window.openUpcart === "function") {
          window.openUpcart();
        } else {
          document.dispatchEvent(new CustomEvent("upcart:open", { bubbles: true }));
        }
      } catch (e) {}
      return;
    }
    document.dispatchEvent(
      new CustomEvent("miniCart:itemAdded", { detail: null, bubbles: true })
    );
  }

  _addToCartHelper(formData, { silent = false } = {}){
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          return { status: response.status || 500, description: "Non-JSON cart response" };
        }
        if (!this._cartAddSucceeded(data) || response.status >= 400) {
          console.error("Cart add failed:", data.description || data.message || data);
          return { ...data, status: data.status || response.status };
        }
        if (!silent) {
          this._notifyCartOpened();
        }
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
        return null;
      });
  }

  /**
   * AWS createProduct variants can 422 briefly ("Kann Variante nicht finden").
   * Retry a few times before giving up / falling back.
   * On 429 (rate limit), stop immediately — more retries make Shopify angrier.
   */
  async _addParentWithRetry(parentItem, { attempts = 3, delayMs = 900 } = {}) {
    let last = null;
    for (let i = 0; i < attempts; i++) {
      if (i > 0) await new Promise((r) => setTimeout(r, delayMs));
      last = await this._addToCartHelper({ items: [parentItem] }, { silent: true });
      if (this._cartAddSucceeded(last)) return last;
      if (last && Number(last.status) === 429) return last;
    }
    return last;
  }

  _openMiniCart() {
    this._notifyCartOpened();
  }

  /**
   * Add Sparset first, then base. Returns { ok, rateLimited }.
   * Does not open mini-cart when the add fully failed (avoids empty/stale cart UI).
   * @param {object|null} fallbackVariantId catalog id — ONLY when no dynamic price variant
   * @param {{ attempts?: number, delayMs?: number }} retryOpts
   */
  async _addBundleAndBase(parentItem, baseItem, fallbackVariantId, retryOpts = {}){
    const attempts = retryOpts.attempts || 3;
    const delayMs = retryOpts.delayMs || 900;
    let parentOk = await this._addParentWithRetry(parentItem, { attempts, delayMs });
    const rateLimited = !!(parentOk && Number(parentOk.status) === 429);

    // Catalog fallback only when explicitly allowed (createProduct failed).
    // Never use it after a dynamic priced variant — that causes ~19,99 € wrong price.
    if (!this._cartAddSucceeded(parentOk) && fallbackVariantId && !rateLimited) {
      const fallbackId = normalizeVariantId(fallbackVariantId);
      const primaryId = normalizeVariantId(parentItem.id);
      if (fallbackId && primaryId && fallbackId !== primaryId) {
        parentOk = await this._addToCartHelper(
          { items: [{ ...parentItem, id: fallbackId }] },
          { silent: true }
        );
      }
    }

    if (!this._cartAddSucceeded(parentOk)) {
      console.warn(
        rateLimited
          ? "Cart rate-limited (429). Wait a minute, then try again."
          : "Bundle parent could not be added to cart."
      );
      return { ok: false, rateLimited };
    }

    if (baseItem) {
      const baseOk = await this._addToCartHelper({ items: [baseItem] }, { silent: false });
      // Parent is in cart even if base fails — still open mini-cart
      if (!this._cartAddSucceeded(baseOk)) {
        this._openMiniCart();
        return { ok: true, baseFailed: true, rateLimited: !!(baseOk && Number(baseOk.status) === 429) };
      }
      return { ok: true };
    }

    this._openMiniCart();
    return { ok: true };
  }

  addToCartNormal(id,quantity,baseVariantId){
        const parentItem = {
          id,
          quantity
        };

        const baseId = parseInt(baseVariantId, 10);
        let baseItem = null;
        if (Number.isFinite(baseId) && baseId > 0) {
          baseItem = {
            id: baseId,
            quantity: parseInt(quantity, 10) || 1,
            properties: {
              "_bundle-base": true
            }
          };
        }

        return this._addBundleAndBase(parentItem, baseItem);
  }

  addToCart(id,quantity,baseVariantId,fallbackVariantId,retryOpts){

    if (!id) {
      console.error("Parent product ID is required to add bundle to cart.");
      return Promise.resolve({ ok: false });
    }
      // ✅ generate unique set id
    const uniqueSetId = Math.random().toString(36).substring(2, 10);

    // ✅ group items by id and count quantity
    const grouped = this.items.reduce((acc, item) => {
      if (!acc[item.id]) {
        acc[item.id] = { ...item, quantity: 0 };
      }
      acc[item.id].quantity += 1;
      return acc;
    }, {});

    // ✅ build child items json
    const childItemsJson = JSON.stringify(
      Object.values(grouped).map(i => ({
        id: i.id,
        quantity: i.quantity,
        customKey: i.price ?? 0, // fallback if no price
        img: i.img,
        title: i.name
      }))
    );

    // ✅ free variants (comma separated IDs)
    const freeVariants = this.items.map(i => i.id).join(",");

    // Visible labels for Upcart (underscore props stay hidden).
    // createProduct parents have option "Title: …timestamp" — "Designs" replaces that UX.
    // Design 1..N lists the chosen covers so the cart isn't a single nameless set line.
    const designCount =
      Number(this.get("freeItems")) || this.items.length || 0;
    const designLabel =
      designCount > 0 ? `${designCount} Designs` : "";

    const parentProperties = {
      "_bundle-parent": true,
      "_set": uniqueSetId,
      "_childItemsJson": childItemsJson,
      "_free_variants": freeVariants
    };
    if (designLabel) {
      parentProperties.Designs = designLabel;
    }
    this.items.forEach((item, index) => {
      const name = (item && item.name ? String(item.name) : "").trim();
      if (name) {
        parentProperties[`Design ${index + 1}`] = name;
      }
    });

    // Numeric variant id (plain number or Shopify GID)
    let parentId = normalizeVariantId(id);
    if (!parentId) {
      console.error("Invalid Sparset parent variant id:", id);
      return Promise.resolve({ ok: false });
    }

    const parentItem = {
      id: parentId,
      quantity: parseInt(quantity, 10) || 1,
      properties: parentProperties
    };

    // Optional selected base (Leo / Schwarz / Pink) as its own cart line
    let baseItem = null;
    const baseId = parseInt(baseVariantId, 10);
    if (Number.isFinite(baseId) && baseId > 0) {
      baseItem = {
        id: baseId,
        quantity: parseInt(quantity, 10) || 1,
        properties: {
          "_bundle-base": true,
          "_set": uniqueSetId
        }
      };
    }

    return this._addBundleAndBase(parentItem, baseItem, fallbackVariantId, retryOpts || {});

  }

  add(item) {
    // ✅ enforce maxItems
    if (this._state.maxItems > 0 && this.items.length >= this._state.maxItems) {
      console.warn("Max items reached, cannot add more.");
      return;
    }
    this.items.push({...item});
    this._calculateCartPrice();
    this.notify();
  }

  removeOne(id) {
    const index = this.items.findIndex(i => i.id === id);
    if (index !== -1) {
      this.items.splice(index, 1);
      this._calculateCartPrice();
      this.notify();
    }
  }

  remove(id) {
    this.items = this.items.filter(i => i.id !== id);
    this._calculateCartPrice();
    this.notify();
  }

  count(id) {
    return this.items.filter(i => i.id === id).length;
  }

  trimTo(limit) {
    const n = Number(limit);
    if (!Number.isFinite(n) || n < 0) {
      console.warn("trimTo: invalid limit", limit);
      return;
    }

    if (this.items.length > n) {
      this.items = this.items.slice(0, n);
      this.notify();
    }
  }
}

/** Parse design count from variant option like "3 Designs" / "4 Desgins" (typo). */
function resolveBundleFreeItems(metafields, variant) {
  const fromMeta = Number(metafields?.free_items);
  if (Number.isFinite(fromMeta) && fromMeta > 0) {
    return { count: fromMeta, inferred: false };
  }

  const label = String(variant?.option1 || variant?.title || "");
  // Only treat Design-bundle options as counts — never "Einzelstück" or unrelated options
  const match = label.match(/^\s*(\d+)\s*Desig/i);
  if (match) {
    const parsed = Number(match[1]);
    if (Number.isFinite(parsed) && parsed > 0) {
      return { count: parsed, inferred: true };
    }
  }
  return { count: 0, inferred: false };
}

function resolveBundleDiscount(metafields, freeItems, inferredFromOption) {
  const fromMeta = Number(metafields?.discount_percentage);
  if (Number.isFinite(fromMeta) && fromMeta > 0) return fromMeta;

  // Only invent discounts when free_items itself was inferred (metafields missing)
  if (!inferredFromOption) return 0;

  const defaults = { 3: 15, 4: 20, 6: 25 };
  return defaults[freeItems] || 0;
}

window.ColorSelectionStore = new ColorSelectionStore();


class AutoVariantSelector {
  constructor(variantMetafields = {}, store) {
    this.variantMetafields = variantMetafields; // the map you defined
    this.store = store; // instance of ColorSelectionStore
    this.currentVariantId = null;
  }

  setVariantMetafields(variantMetafields) {
    this.variantMetafields = variantMetafields || {};
  }

  setVariant(variantId) {
    this.currentVariantId = variantId;
  }

  addItem(item) {
    const variantMeta = this.variantMetafields[this.currentVariantId] || {};
    const { count: freeLimit } = resolveBundleFreeItems(
      variantMeta,
      (window.productData?.variants || []).find(
        (v) => String(v.id) === String(this.currentVariantId)
      )
    );
    if (!freeLimit) {
      console.warn("No free_items for variant", this.currentVariantId);
      return;
    }

    const currentCount = this.store.getItems().length;

    // Case 1: still within free limit
    if (currentCount < freeLimit) {
      this.store.add(item);
      return;
    }

    // Case 2: exceeded limit → try to upgrade
    const nextVariantId = this.findNextVariant(freeLimit);
    if (nextVariantId) {
      this.currentVariantId = nextVariantId;
      this.store.add(item);

      // 🔥 Optionally trigger Shopify variant change event
      const event = new CustomEvent("variant:update:selection", {
        detail: { variantId: nextVariantId },
        bubbles: true,
        composed: true
      });
      document.dispatchEvent(event);
    } else {
      // Case 3: no upgrade available → stop selection
      console.warn("Reached max allowed items. Cannot add more.");
    }
  }

  removeItem(id) {
    this.store.removeOne(id);
    this.syncVariantToItemCount();
  }

  /** Tightest Sparset whose free_items still fits the selected count (e.g. 4 → 4 Designs). */
  findBestVariantForCount(itemCount) {
    let best = null;
    let bestFree = Infinity;

    Object.entries(this.variantMetafields).forEach(([id, meta]) => {
      const { count: free } = resolveBundleFreeItems(
        meta,
        (window.productData?.variants || []).find((v) => String(v.id) === String(id))
      );
      if (free > 0 && free >= itemCount && free < bestFree) {
        best = id;
        bestFree = free;
      }
    });

    return best;
  }

  /**
   * After removals: if fewer designs are selected than the current Sparset,
   * switch down (6→4→3) so % matches count. Never upgrades here.
   */
  syncVariantToItemCount() {
    const itemCount = this.store.getItems().length;
    if (itemCount <= 0) return;

    const currentMeta = this.variantMetafields[this.currentVariantId] || {};
    const { count: currentFree } = resolveBundleFreeItems(
      currentMeta,
      (window.productData?.variants || []).find(
        (v) => String(v.id) === String(this.currentVariantId)
      )
    );
    if (!currentFree) return;

    const bestId = this.findBestVariantForCount(itemCount);
    if (!bestId || String(bestId) === String(this.currentVariantId)) return;

    const bestMeta = this.variantMetafields[bestId] || {};
    const { count: bestFree } = resolveBundleFreeItems(
      bestMeta,
      (window.productData?.variants || []).find((v) => String(v.id) === String(bestId))
    );

    // Only move to a smaller Sparset (downgrade). Leave upgrade path to addItem.
    if (!(bestFree > 0 && bestFree < currentFree)) return;

    this.currentVariantId = bestId;
    document.dispatchEvent(
      new CustomEvent("variant:update:selection", {
        detail: { variantId: bestId },
        bubbles: true,
        composed: true,
      })
    );
  }

  findNextVariant(currentFreeLimit) {
    let next = null;
    let nextFree = Infinity;

    Object.entries(this.variantMetafields).forEach(([id, meta]) => {
      const { count: free } = resolveBundleFreeItems(
        meta,
        (window.productData?.variants || []).find((v) => String(v.id) === String(id))
      );
      if (free > currentFreeLimit && free < nextFree) {
        next = id;
        nextFree = free;
      }
    });

    return next;
  }
}

// Usage:
const autoSelector = new AutoVariantSelector({}, window.ColorSelectionStore);

// Later, when metafields are available
if (window.variantMetafields) {
  autoSelector.setVariantMetafields(window.variantMetafields);
} else {
  // Or wait until metafields are set dynamically
  const observer = setInterval(() => {
    if (window.variantMetafields) {
      autoSelector.setVariantMetafields(window.variantMetafields);
      clearInterval(observer);
      // console.log("Metafields loaded ✅");
    }
  }, 100);
}

/* ---- Selection Grid ---- */
class ColorSelectionGrid extends HTMLElement {
  connectedCallback() {
    // Prevent double-init (HMR / re-attach) which can stack grids
    if (this._booted) return;
    this._booted = true;

    // Always start clean — never keep Liquid/SSR children beside JS output
    this.innerHTML = '';
    this.removeAttribute('data-ready');

    const {maxItems,freeItems,optionalItems,requiredOff,optionalOff,defaultVariant} = this.dataset;
    autoSelector.setVariant(defaultVariant);
    const store = window.ColorSelectionStore;

    const variantId = defaultVariant;
    const metafields = (window.variantMetafields && window.variantMetafields[variantId]) || {};
    const productVariant = (window.productData?.variants || []).find(
      (v) => String(v.id) === String(variantId)
    );
    const resolved = resolveBundleFreeItems(
      { free_items: freeItems ?? metafields.free_items },
      productVariant
    );
    const resolvedOff = resolveBundleDiscount(
      { discount_percentage: requiredOff ?? metafields.discount_percentage },
      resolved.count,
      resolved.inferred
    );

    store.set('maxItems', Number(maxItems) || resolved.count || 0);
    store.set('freeItems', resolved.count);
    store.set('optionalItems', optionalItems);
    store.set('requiredOff', resolvedOff);
    store.set('optionalOff', optionalOff);

    this._unsubRender = store.subscribe(() => this.render());
    this._unsubButton = store.subscribe(() => toggleBundleButton());
    this.setAttribute('data-ready', 'true');

    document.addEventListener("variant:change", this._onVariantChange);
  }


  disconnectedCallback() {
    document.removeEventListener("variant:change", this._onVariantChange);
    if (typeof this._unsubRender === 'function') this._unsubRender();
    if (typeof this._unsubButton === 'function') this._unsubButton();
    this._unsubRender = null;
    this._unsubButton = null;
    this._booted = false;
  }

  _onVariantChange = (e) => {
    const store = window.ColorSelectionStore;
    const variant = e.detail.variant;
    const id = variant?.id;
    if(!id) return;
    autoSelector.setVariant(id)
    const metafields = (window.variantMetafields && window.variantMetafields[id]) || {};
    const resolved = resolveBundleFreeItems(metafields, variant);
    const requiredOff = resolveBundleDiscount(metafields, resolved.count, resolved.inferred);
    store.set("freeItems", resolved.count);
    store.set("requiredOff", requiredOff);
    store.trimTo(resolved.count);
    toggleBundleButton(variant);
  }

  render() {
    const store = window.ColorSelectionStore;
    const {requiredOff} = store._state;
    const freeItems = Number(store.get('freeItems'));
    const optionalItems = Number(store.get('optionalItems'));
    const items = store.getItems();

    // Einzelstück / non-bundle variants: hide the design picker
    if(!freeItems) {
      this.innerHTML = '';
      return;
    }

    //Build the grid content
    let gridContent = "";

    // -- Step 1 & 2: Fill freeItems slots ---
    for(let i = 0; i < freeItems; i++){
      if(items[i]){
        //Replace placeholder with actual selected item
        const item = items[i];
        gridContent += `
            <color-switcher-item
              class="color-selection__grid-item required-switcher coladded" 
              data-count="${i+1}" data-total-count="${freeItems}"
              data-type="item"
              data-id="${item.id}"
              data-name="${item.name}"
              data-img="${item.img}"
              data-vendor="${item.vendor}"
              data-price="${item.price}"
              data-compare="${item.compare}"
              data-count=${i + 1}>
            </color-switcher-item>
        `
      }else{
        //Empty placeholder card
        gridContent +=`
            <color-switcher-item
              data-type="placeholder"
              class="color-selection__grid-item required-switcher" 
              data-count="${i+1}" data-total-count="${freeItems}">
            </color-switcher-item>
        `;
      }
    }

    // -- Step 4: Add optional card if needed
    // if(optionalItems > 0){
    //   gridContent +=`
    //     <color-switcher-item
    //       data-type="optional"
    //       class="color-selection__grid-item optional-switcher" 
    //     >
    //     </color-switcher-item>
    //   `;
    // }

    this.innerHTML = `
      <div class="color-selection__container">
        <div class="color-selection__label">         
          <h4 class="color-selection__label_heading">Wähle Deine Designs:</h4>
          <div class="color-selection__label_text">
            <span class="unfilled" style="color: rgb(39, 39, 39);">
              <span class="set-no-color_selected">${items?.length <= freeItems ? items.length : freeItems}</span> von
              <span class="set-no-color">${freeItems}</span> ausgewählt</span>
          </div>
        </div>
        <div class="color-selection__grid  more-colors-grid">
          ${gridContent}
        </div>
      </div>
    `;
  }
}
if (!customElements.get("color-selection-grid")) {
  customElements.define("color-selection-grid", ColorSelectionGrid);
}

/* ---- Grid Item ---- */
class ColorSwitcherItem extends HTMLElement {
  connectedCallback() {
    const store = window.ColorSelectionStore;
    const {requiredOff} = store._state;
    const {type,id, name, img, vendor, price, compare,count} = this.dataset;

    
    this.innerHTML = `
          <color-switcher class="color-selection__image color-selection__item required-switcher color-selection__image--top pi-4 active ${type === 'item' ? 'coladded' : ''}" 
            style="${img ? `background-image: url('${imgUrl(img,'200x')}');` : ''}">
              <span class="discounted_percent">-${requiredOff}%</span>
            <button class="remove_item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </color-switcher>
          <div class="farbe-title">${
            type === "item" ? name :
            type === "placeholder" ? "Design "+count :
            type === "optional" ? "Optional Design" : ""
          }</div>
          
          <div class="farbe-price_wrapper">
            <div class="farbe-price"><span class="money">${price ? w(parseFloat(price),window.theme.currency.moneyFormat) : ''}</span></div>
            ${(typeof compare == 'undefined' || compare == 'undefined') ? '' : 
              `<div class="farbe-compare"><span class="money">${w(parseFloat(compare),window.theme.currency.moneyFormat)}</span></div>`
            }
          </div>
    `;

    // <div class="farbe-vendor">${vendor || ''}</div>

    this.querySelector(".remove_item").addEventListener("click", (e) => {
      e.stopPropagation();
      // Only real selected designs can remove / trigger Sparset downgrade
      if (type !== "item" || !id) return;
      autoSelector.removeItem(id);
    });

    type !== 'item' && this.addEventListener('click', () => {
      document.querySelector('color-choose-drawer')?.open();
    })
  }
}
customElements.define("color-switcher-item", ColorSwitcherItem);

/* ---- Drawer ---- */
class ColorChooseDrawer extends HTMLElement {

  constructor() {
    super();

    this.overlay = null;
    this.products = [];
    this.cursor = null;
    this.hasNextPage = true;
    this.loading = false;
  }
  connectedCallback() {
    this.products = JSON.parse(this.dataset.products || "[]");
    this.collectionHandle = this.dataset.collection;
    this.overlay = document.querySelector('.drawer-overlay');
    this.overlay.addEventListener('click',this.close.bind(this))
    // this.render();
    this.loadMore()
    window.ColorSelectionStore.subscribe(() => this.updateSlider());
  }

  async loadMore() {
    if(!this.hasNextPage || this.loading) return;
    this.loading = true;

    const query = `
      query($handle: String!, $cursor: String) @inContext(country: ${Shopify?.country || 'DE'}){
        collection(handle: $handle){
          products(first: 40, after: $cursor){
            edges {
              cursor
              node {
                id
                title
                availableForSale
                tags
                images(first: 5) {edges { node { url } } }
                variants(first: 1){
                  edges {
                    node {
                      id
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
            pageInfo { hasNextPage }
          }
        }
      }
    `;

    const resp = await fetch('https://getfabulous-de.myshopify.com/api/2024-07/graphql.json',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '769d8a51c795950e4aaf2de12570bf5b'
      },
      body: JSON.stringify({
        query,
        variables: { handle: this.collectionHandle, cursor: this.cursor },
        extensions: {country: Shopify?.country || 'DE'}
      })
    })

    const json = await resp.json();
    const edges = json.data.collection.products.edges;

    this.cursor = edges.length ? edges[edges.length - 1].cursor : null;
    this.hasNextPage = json.data.collection.products.pageInfo.hasNextPage;
    this.renderMore(edges.map(e => e.node));
    this.loading = false;
  }

  onScroll() {
    if(!this.hasNextPage || this.loading) return;
    const el = this.querySelector('.drawer__content');
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 300;
    if (nearBottom) {
      this.loadMore();
    }
  }


  disconnectedCallback(){
    this.querySelector(".icon-close").removeEventListener("click", () => this.close());
  }

  open() {
    this.classList.add('-active');
    this.overlay.classList.add('active')
  }
  close() { 
    
    this.classList.remove('-active');
    this.overlay.classList.remove('active')
  }

  renderMore(newProducts) {
    const container = this.querySelector('.product-tiles') || this.createContainer();
    
    container.insertAdjacentHTML(
      'beforeend',
      newProducts.map(p => this.template(p)).join('')
    );
  }

  template(p) {
    
    if (!p.tags.includes('bundle_item') || !p.availableForSale) return '';
    // console.log("Product",p)
    const default_variant = p.variants.edges[0].node;
    const imgs = p.images.edges.map((edge)=>edge.node.url).join(',');
    const price = default_variant.price?.amount;
    const compare_at_price = default_variant.compare_at_price?.amount;
    return `
      <drawer-product-item
        class="product-tile-item"
        data-id="${default_variant.id}"
        data-name="${p.title}"
        data-imgs="${imgs}"
        data-price="${price}"
        data-compare="${compare_at_price ? (compare_at_price) : (price)}">
      </drawer-product-item>`;
  }

  createContainer() {
    this.innerHTML = `
      <div class="drawer__header">
        <p>Choose your designs</p>
        <i class="icon icon-close"></i>
      </div>
      <div class="drawer__content">
        <div class="product-tiles"></div>
      </div>
      <selected-slider></selected-slider>
    `;
    this.querySelector('.icon-close').addEventListener('click', () => this.close());
    this.querySelector('.drawer__content').addEventListener('scroll',this.onScroll.bind(this));
    return this.querySelector('.product-tiles');
  }

  // render() {
  //   // console.log("Products",this.products)
  //   this.innerHTML = `
  //     <div class="drawer__header">
  //   <p>Choose your designs</p>
  //   <i class="icon icon-close"></i>
  // </div>
  // <div class="drawer__content ">
  //   <div class="product-tiles">
  //       ${this.products.map(p =>
  //         {
  //           if(p.tags.includes('bundle_item') && p.available){
  //             return `
  //               <drawer-product-item
  //                 class="product-tile-item"
  //                 data-id="${p.id}"
  //                 data-name="${p.title}"
  //                 data-imgs="${p.images}"
  //                 data-vendor="${p.vendor}"
  //                 data-price="${p.price/100}",
  //                 data-compare="${p.compare_at_price ? (p.compare_at_price/100) : (p.price/100)}">
  //               </drawer-product-item>
  //             `;
  //           }else{
  //             return '' 
  //           }
  //         }).join("")}
  //   </div>
  //   </div>

  //   <selected-slider></selected-slider>
  //   `;
  //   this.querySelector(".icon-close").addEventListener("click", () => this.close());


  // }

  updateSlider() {
    this.querySelector("selected-slider")?.render();
  }
}
customElements.define("color-choose-drawer", ColorChooseDrawer);


function formatMoney(amount,currencyCode) {
  if(!amount || !currencyCode) return;
  return new Intl.NumberFormat(Shopify.locale,
    { style: 'currency', currency: currencyCode }
  ).format(amount);
}

function convertPrice(price, rate, buyerCurrency) {
  // price = { amount: "19.95", currency_code: "EUR" }
  const baseAmount = parseFloat(price.amount);

  // convert with your known rate
  const converted = baseAmount * rate;

  // format in buyer’s local currency
  return formatMoney(converted,buyerCurrency)
}

/**
 * Legacy helper used by createProduct.
 * Caller passes (buttonTotalMajor * 100); dividing by Shopify.currency.rate
 * yields store-currency cents as a string (e.g. "6230.09").
 * AWS API treats that as cents and creates a variant priced in major units (e.g. 62.30).
 */
function convertToStoreCurrency(priceInActive) {
  const amount = parseFloat(priceInActive);
  if (!Number.isFinite(amount) || amount < 0) return "0.00";
  const rate = parseFloat(window.Shopify?.currency?.rate);
  if (!Number.isFinite(rate) || rate <= 0) return amount.toFixed(2);
  return (amount / rate).toFixed(2);
}

function normalizeVariantId(id) {
  if (id == null || id === "") return null;
  if (typeof id === "number" && Number.isFinite(id) && id > 0) return id;
  const s = String(id);
  if (/^\d+$/.test(s)) {
    const n = parseInt(s, 10);
    return n > 0 ? n : null;
  }
  const m = s.match(/(\d+)\s*$/);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return n > 0 ? n : null;
}

/** Brief pause so a just-created AWS variant is purchasable on the storefront. */
function waitMs(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * createProduct then resolve a storefront-ready variant id.
 * Retries once if the first call returns no variant.
 */
async function createPricedBundleVariant(priceMajor) {
  const centsInput = Number(priceMajor) * 100;
  let product = await createProduct(centsInput);
  let dynamicId = normalizeVariantId(product?.variant?.id);
  if (!dynamicId) {
    await waitMs(400);
    product = await createProduct(centsInput);
    dynamicId = normalizeVariantId(product?.variant?.id);
  }
  return dynamicId;
}

/* ---- Drawer Product Item ---- */
class DrawerProductItem extends HTMLElement {
  connectedCallback() {
    const store = window.ColorSelectionStore;
    const {id, name, imgs, vendor, price, compare} = this.dataset;
    let images = imgs.split(',');
    let img = imgs.split(',').length > 0 ? imgs.split(',')[0] : null;
    this.innerHTML = `
            <div class="product-item__label-list label-list">
          <span class="label label--custom percentOff" style="">-25%</span>
        </div>
        <div class="added_tag_inner">
          <div class="added_tag_main">
            <div class="quantity-selector">
                <button type="button" class="quantity-selector__button quantity_minus">
                  <span class="visually-hidden"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">Reduce quantity</font></font></span>
                  <svg focusable="false" width="10" height="2" class="icon icon--minus-big product_item_minus" viewBox="0 0 10 2">
                      <path fill="currentColor" d="M0 0h10v2H0z"></path>
                  </svg>
                </button>
                <input type="number" is="input-number" class="quantity-selector__input" inputmode="numeric" name="quantity" autocomplete="off" value="1" step="1" min="1" aria-label="Crowd" readonly="">
                <button type="button" class="quantity-selector__button quantity_plus">
                  <span class="visually-hidden"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">Increase quantity</font></font></span>
                  <svg focusable="false" width="10" height="10" class="icon icon--plus-big product_item_plus" viewBox="0 0 10 10">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6v4h2V6h4V4H6V0H4v4H0v2h4z" fill="currentColor"></path>
                  </svg>
                </button>
            </div>
          </div>
        </div>
        <div class="tile-media tile-media-slider swiper-container" data-next-enabled="true">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
          ${images.map((img)=>`<div class="product-card__image u-aspect-ratio swiper-slide" style="--aspect-ratio: 1;">
                  
                  <img class="swiper-lazy lazy fade-in" src="${imgUrl(img,'200x')}" alt="Doonails" height="150" width="150" class="tile-media_img_1">
                </div>`).join("")}
          </div>

        </div>
        <div class="product-details">
          
          <p class="title">${name}</p>
        </div>
    `;


    this.addedTagInner = this.querySelector(".added_tag_inner");
    this.input = this.querySelector(".quantity-selector__input");

    const discountedPrice = (price,discount) =>{
        if(discount){
          return price - ((discount*price)/100);
        }else{
          return price;
        }
    }


    // Plus button = add
    this.querySelector(".quantity_plus").addEventListener("click", (e) => {
      e.stopPropagation();
      const {requiredOff} = store._state;
      autoSelector.addItem({ id, name, img, vendor, price:discountedPrice(compare,requiredOff), compare })
    });

    // Minus button = remove one
    this.querySelector(".quantity_minus").addEventListener("click", (e) => {
      e.stopPropagation();
      autoSelector.removeItem(id);
    });

    // Keep UI synced
    store.subscribe(() => {
      const qty = store.count(id);
      if (qty > 0) {
        this.addedTagInner.style.display = "block";
        this.input.value = qty;
      } else {
        this.addedTagInner.style.display = "none";
        this.input.value = 0;
      }
    });

    // Initial render
    const initialQty = store.count(id);
    if (initialQty > 0) {
      this.addedTagInner.style.display = "block";
      this.input.value = initialQty;
    } else {
      this.addedTagInner.style.display = "none";
      this.input.value = 0;
    }


    // Host click listener: use capture to catch the click early
    const onHostClick = (ev) => {
      const {requiredOff} = store._state;
      // If click originated inside the quantity selector, ignore
      if (ev.target.closest(".quantity-selector")) return;

      // ensure store exists
      if (!store || typeof store?.add !== "function") {
        console.warn("[DrawerProductItem] ColorSelectionStore not available yet");
        return;
      }

      const payload = {
        id: String(id),
        name,
        img,
        vendor,
        price:discountedPrice(compare,requiredOff),
        compare,
        quantity: parseInt(this.input.value || "1", 10)
      };

      console.log("[DrawerProductItem] adding to store", payload);
      autoSelector.addItem(payload)
    };

    // use capture:true to make it more robust against other listeners that call stopPropagation in bubble phase
    this.addEventListener("click", onHostClick, { capture: true });

    // keep ref if you want to remove later
    this._onHostClick = onHostClick;
  }

  disconnectedCallback() {
    if (this._onHostClick) this.removeEventListener("click", this._onHostClick, { capture: true });
  }
}
customElements.define("drawer-product-item", DrawerProductItem);

/* ---- Slider ---- */
class SelectedSlider extends HTMLElement {

  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.maxItems = window.ColorSelectionStore?.get("maxItems") || 20; // fallback
    this.render();
    window.ColorSelectionStore.subscribe(() => this.render());
  }
  render() {

    const state = window.ColorSelectionStore._state; // full state
    const items = window.ColorSelectionStore.getItems() || [];
    const maxItems = state.maxItems || this.maxItems;
    const placeholderImg = "https://cdn.shopify.com/s/files/1/0367/4233/2475/files/new-item-bg.png?v=1757329451";

    // Build slots (real items first, placeholders after)
    const slots = Array.from({ length: maxItems }).map((_, i) => {
      const item = items[i];
      const img = item ? item.img : placeholderImg;
      const selected = item ? "coladded" : "";
      return `
        <div class="selected_item swiper-slide ${selected}" 
             data-index="${i + 1}" 
             data-max-color="${maxItems}" 
             style="background-image: url('${img}')">
        </div>
      `;
    });

    if(!items || items.length <= 0){
      this.innerHTML = '';
    }

    this.innerHTML = `
      <div class="${items && items.length > 0 && 'active'} color_choose_guarantee_inner">
          <div class="color_selected_inner">
            <div class="color_selected_main">
              <div class="swiper-container color_selected_slider">
                <div class="swiper-wrapper" style="height:40px">
                  ${slots.join("")}
                </div>
              </div>
            </div>
          </div>
      </div>


      <div class="slider">
        ${window.ColorSelectionStore?.items?.map(i => `
          <div class="selected-item" style="background-image:url(${i.img})"></div>
        `).join("")}
      </div>
    `;

    this.initSwiper();
  }

  initSwiper() {
    const container = this.querySelector(".color_selected_slider");

    if (this.swiper) {
      this.swiper.destroy(true, true); // destroy old instance
    }

    if (container) {
      this.swiper = new Swiper(container, {
        direction: "horizontal",
        loop: false,
        preloadImages: false,
        lazy: true
      });
    }
  }
}
customElements.define("selected-slider", SelectedSlider);

function toggleBundleButton(variant = null) {
  const store = window.ColorSelectionStore;
  const {price,compare} = store.getCartPrice();
  const freeItems = Number(store.get('freeItems'));
  const items = store.getItems().length;

  const btn = document.querySelector(".product-bundle-add-to-cart--js");
  if (!btn) return;

  if(freeItems == 0){
    
    if(variant){
      if(variant.compare_at_price){
        btn.innerHTML = `<p>In den Warenkorb |  
        <span style="text-decoration:line-through;">${w(parseFloat(variant.compare_at_price/100),window.theme.currency.moneyFormat)}</span>
        <span>${w(parseFloat(variant.price/100),window.theme.currency.moneyFormat)}</span></p>`;
      }else{
        btn.innerHTML = `<p>In den Warenkorb |
        <span>${w(parseFloat(variant.price/100),window.theme.currency.moneyFormat)}</span></p>`;
      }
    }else{
      btn.innerHTML = `<p>In den Warenkorb</p>`;
    }
  }else if (items >= freeItems && freeItems != 0) {
    btn.innerHTML = `<p>In den Warenkorb | 
    <span style="text-decoration:line-through;">${w(parseFloat(compare),window.theme.currency.moneyFormat)}</span>
    <span>${w(parseFloat(price),window.theme.currency.moneyFormat)}</span></p>`;
  } else {
    btn.innerHTML = `<p>Wähle Dein Design  ${items + 1}</p>`;
  }
}

/* ---- Base selection (optional; does not navigate away) ---- */

const GF_BASE_STORAGE_KEY = 'gf_selected_base_variant_id';

function getSelectedBaseVariantId() {
  const input = document.getElementById('selected-base-variant-id');
  if (input && input.value) return input.value;

  // Fallback: selected button may have the id even if hidden input was cleared
  const selected = document.querySelector(
    '.custom_base-list.is-selected[data-variant-id], .custom_base-list[aria-pressed="true"][data-variant-id]'
  );
  if (selected) {
    const fromBtn = selected.getAttribute('data-variant-id') || '';
    if (fromBtn) return fromBtn;
  }

  // Survive section re-renders / variant switches
  try {
    return sessionStorage.getItem(GF_BASE_STORAGE_KEY) || '';
  } catch (e) {
    return '';
  }
}

async function resolveBaseVariantId(btn) {
  const existing = btn.getAttribute('data-variant-id');
  if (existing) return existing;

  const handle = btn.getAttribute('data-base-handle');
  if (!handle) return '';

  try {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
    if (!res.ok) return '';
    const product = await res.json();
    const variants = product.variants || [];
    const variant = variants.find((v) => v.available) || variants[0];
    if (!variant || !variant.id) return '';
    const id = String(variant.id);
    btn.setAttribute('data-variant-id', id);
    return id;
  } catch (err) {
    console.error('Base variant resolve failed:', err);
    return '';
  }
}

function setWeiterOhneBasisPressed(pressed) {
  document.querySelectorAll('.weiter-ohne-basis').forEach((el) => {
    el.classList.toggle('is-active', !!pressed);
    el.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  });
}

/** Clear Leo/Pink/Schwarz selection only — does not change the cart. */
function clearBaseSelection() {
  document.querySelectorAll('.custom_base-list').forEach((el) => {
    el.classList.remove('is-selected');
    el.setAttribute('aria-pressed', 'false');
  });

  const input = document.getElementById('selected-base-variant-id');
  if (input) input.value = '';

  try {
    sessionStorage.removeItem(GF_BASE_STORAGE_KEY);
  } catch (e) {}

  setWeiterOhneBasisPressed(true);
}

/** Scroll to step 2: Sparset / Designs variant block. */
function scrollToSparsetStep() {
  const step =
    document.getElementById('gf-step-sparset') ||
    document.querySelector('.custom_product-form-design') ||
    document.querySelector('color-selection-grid');
  if (!step || typeof step.scrollIntoView !== 'function') return;
  try {
    step.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } catch (e) {
    step.scrollIntoView(true);
  }
}

function markBaseSelected(btn, variantId) {
  const container = btn.closest('.custom_base');
  if (!container) return;

  container.querySelectorAll('.custom_base-list').forEach((el) => {
    el.classList.remove('is-selected');
    el.setAttribute('aria-pressed', 'false');
  });

  btn.classList.add('is-selected');
  btn.setAttribute('aria-pressed', 'true');

  const input = document.getElementById('selected-base-variant-id');
  if (input) input.value = variantId || '';

  try {
    if (variantId) sessionStorage.setItem(GF_BASE_STORAGE_KEY, String(variantId));
    else sessionStorage.removeItem(GF_BASE_STORAGE_KEY);
  } catch (e) {}

  // Choosing a base cancels "shop without base"
  setWeiterOhneBasisPressed(false);
}

function restoreBaseSelectionFromStorage() {
  let saved = '';
  try {
    saved = sessionStorage.getItem(GF_BASE_STORAGE_KEY) || '';
  } catch (e) {
    return;
  }
  if (!saved) return;

  const btn = document.querySelector(`.custom_base-list[data-variant-id="${saved}"]`);
  if (btn && !btn.disabled) {
    markBaseSelected(btn, saved);
    return;
  }

  // Handle-only buttons (variant id resolved later)
  document.querySelectorAll('.custom_base-list[data-base-handle]').forEach(async (el) => {
    const id = await resolveBaseVariantId(el);
    if (id && String(id) === String(saved)) markBaseSelected(el, id);
  });
}

document.addEventListener('click', async function (e) {
  const skipBtn = e.target.closest('.weiter-ohne-basis');
  if (skipBtn) {
    e.preventDefault();
    e.stopPropagation();
    // Client: clear base selection + scroll to Sparset step. Do not touch cart.
    clearBaseSelection();
    scrollToSparsetStep();
    return;
  }

  const btn = e.target.closest('.custom_base-list[data-base-handle]');
  if (!btn || btn.disabled) return;

  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.baseResolving === '1') return;
  btn.dataset.baseResolving = '1';

  try {
    const variantId = await resolveBaseVariantId(btn);
    if (!variantId) {
      console.warn('Could not resolve base variant for', btn.getAttribute('data-base-handle'));
      return;
    }
    markBaseSelected(btn, variantId);
  } finally {
    delete btn.dataset.baseResolving;
  }
});

document.addEventListener('DOMContentLoaded', restoreBaseSelectionFromStorage);
// In case script loads after DOMContentLoaded
if (document.readyState !== 'loading') {
  restoreBaseSelectionFromStorage();
}

/* ---- Add To Cart (designs / Sparset template only) ---- */

async function handleBundleAddToCartClick(btn) {
  const $btn = $(btn);
  const store = window.ColorSelectionStore;
  if (!store) return;

  // Prevent double-submit while spinner is showing
  if (btn.dataset.atcBusy === '1' || btn.disabled) return;
  btn.dataset.atcBusy = '1';

  const clearBusy = () => {
    btn.dataset.atcBusy = '0';
    $btn.removeClass('loading').prop('disabled', false);
  };

  try {
    const { price } = store.cartPrice;
    const items = store.getItems().length;
    const freeItems = Number(store.get("freeItems"));
    let baseVariantId = getSelectedBaseVariantId();

    // Last-chance resolve from selected base button (handle → variant id)
    if (!baseVariantId) {
      const selectedBtn = document.querySelector(
        '.custom_base-list.is-selected[data-base-handle], .custom_base-list[aria-pressed="true"][data-base-handle]'
      );
      if (selectedBtn) {
        baseVariantId = await resolveBaseVariantId(selectedBtn);
        if (baseVariantId) markBaseSelected(selectedBtn, baseVariantId);
      }
    }

    if (freeItems != 0 && items < freeItems) {
      document.querySelector('color-choose-drawer')?.open();
      clearBusy();
      return;
    }

    const $form = $btn.closest('.product-form');
    let id = $form.find('.product-select-variants').val() || btn.getAttribute('data-id');

    let quantity = parseInt($form.find("input[name='quantity']").val(), 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    if (!id) {
      clearBusy();
      return;
    }

    if (freeItems > 0) {
      $btn.addClass('loading').prop('disabled', true);

      const catalogId = normalizeVariantId(id);
      if (!catalogId) {
        clearBusy();
        return;
      }

      // Dynamic priced variant = button total. Catalog Sparset (~19,99 €) must NOT
      // replace it after a successful create — that was the wrong-price bug.
      let parentVariantId = catalogId;
      let fallbackVariantId = null;
      let retryOpts = { attempts: 3, delayMs: 900 };

      const dynamicId = await createPricedBundleVariant(price);
      if (dynamicId && dynamicId !== catalogId) {
        parentVariantId = dynamicId;
        fallbackVariantId = null;
        // New variants often 422 for ~1s; wait then retry harder (no catalog fallback).
        await waitMs(1200);
        retryOpts = { attempts: 6, delayMs: 1000 };
      } else {
        console.warn(
          'createProduct failed; catalog Sparset used (price may be ~19,99 €, not button total).'
        );
        parentVariantId = catalogId;
        fallbackVariantId = null;
      }

      if (!baseVariantId) baseVariantId = getSelectedBaseVariantId();

      const result = await store.addToCart(
        parentVariantId,
        quantity,
        baseVariantId,
        fallbackVariantId,
        retryOpts
      );
      if (result && result.rateLimited) {
        console.warn('Shopify rate-limited (429). Wait 1–2 minutes, clear cart, retry.');
      } else if (result && result.ok === false && dynamicId) {
        console.warn(
          'Priced Sparset variant could not be added yet. Clear cart, wait a few seconds, retry — do not expect catalog 19,99 €.'
        );
      }
      clearBusy();
    } else {
      $btn.addClass('loading').prop('disabled', true);
      await store.addToCartNormal(id, quantity, baseVariantId);
      clearBusy();
    }
  } catch (err) {
    console.error('Bundle ATC failed:', err);
    clearBusy();
  }
}

// Capture phase: run before Upcart / form listeners so Florence + base stay on our path
document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest?.('.product-bundle-add-to-cart--js');
    if (!btn || btn.disabled || btn.dataset.atcBusy === '1') return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    handleBundleAddToCartClick(btn);
  },
  true
);


async function createProduct(price) {
    const url = 'https://msvhn7yzmi.execute-api.eu-central-1.amazonaws.com/dev/api/variant';

    const shop = window.Shopify.shop;
    const schema = window.productInfo;
    if (!schema?.info) {
      console.warn('createProduct: missing window.productInfo');
      return null;
    }

    try {
      const data = {
          shop: shop,
          title: schema.info.title,
          bundle_title: schema.info.bundle_title,
          tag: schema.tag,
          price: convertToStoreCurrency(price),
          image: schema.info.image,
          weight: schema.info.weight,
          weight_unit: schema.info.weight_unit || schema.info.Weight_unit,
          requires_shipping:
            schema.info.requires_shipping ?? schema.info.Requires_shipping
      };
      const response = await fetch(url,{
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      });

      let product = null;
      try {
        product = await response.json();
      } catch (parseErr) {
        console.warn('createProduct: non-JSON response', response.status);
        return null;
      }

      if (!response.ok) {
        console.warn('createProduct HTTP error', response.status, product);
        // Still accept body if it includes a variant (some gateways return odd status)
      }

      const rawVariantId =
        product?.variant?.id ||
        product?.product?.variants?.[0]?.id ||
        product?.variant_id ||
        null;
      const variantId = normalizeVariantId(rawVariantId);
      if (!variantId) {
        console.warn('createProduct: no usable variant id', product);
        return null;
      }

      return {
        ...product,
        variant: { ...(product.variant || {}), id: variantId }
      };
    } catch (error) {
      console.log("Error",error);
      return null;
    }

}

/**
 * Sparset PDP: ensure Bestseller (4 Designs) is selected after load.
 * Sticky ?variant= (e.g. 6 Designs from a prior visit) can leave the wrong
 * radio checked after JS hydrates — one-shot fix, then user can still pick 3/6.
 */
function preferBestsellerSparsetOnLoad() {
  if (!document.querySelector('color-selection-grid')) return;

  const bestRadio = Array.prototype.find.call(
    document.querySelectorAll('.custom_product-option__list input[type="radio"]'),
    (r) => /4\s*desig/i.test(r.value || '')
  );
  if (!bestRadio || bestRadio.disabled) return;
  if (bestRadio.checked) return;

  bestRadio.click();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(preferBestsellerSparsetOnLoad, 50);
  });
} else {
  setTimeout(preferBestsellerSparsetOnLoad, 50);
}